import { Link, Typography } from '@mui/material';
import { AlertCard } from 'common/ui';

export const SourcingExternalError = () => {
  return (
    <AlertCard title="Something went wrong" type="error">
      <Typography variant="body2" mt={1}>
        Please contact support{' '}
        <Link href="mailto:support@joinpopp.com?subject=Sourcing error">
          contact support
        </Link>{' '}
        if the issue persists.
      </Typography>
    </AlertCard>
  );
};
